/**
 * @generated SignedSource<<681a056214caafe7c0c631da0c9b9a98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmbedEventData$data = {
  readonly __typename: "AuthorizedEvent";
  readonly canWrite: boolean;
  readonly created: string;
  readonly creators: ReadonlyArray<string>;
  readonly description: string | null | undefined;
  readonly hasPassword: boolean;
  readonly id: string;
  readonly isLive: boolean;
  readonly metadata: Record<string, Record<string, string[]>>;
  readonly opencastId: string;
  readonly series: {
    readonly id: string;
    readonly opencastId: string;
    readonly title: string;
  } | null | undefined;
  readonly syncedData: {
    readonly duration: number;
    readonly endTime: string | null | undefined;
    readonly startTime: string | null | undefined;
    readonly thumbnail: string | null | undefined;
    readonly updated: string;
  } | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"VideoPageAuthorizedData">;
  readonly " $fragmentType": "EmbedEventData";
} | {
  readonly __typename: "NotAllowed";
  readonly __typename: "NotAllowed";
  readonly " $fragmentType": "EmbedEventData";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "EmbedEventData";
};
export type EmbedEventData$key = {
  readonly " $data"?: EmbedEventData$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmbedEventData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opencastId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "eventPassword"
    },
    {
      "kind": "RootArgument",
      "name": "eventUser"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmbedEventData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLive",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creators",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "metadata",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canWrite",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPassword",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Series",
          "kind": "LinkedField",
          "name": "series",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v0/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SyncedEventData",
          "kind": "LinkedField",
          "name": "syncedData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "duration",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "thumbnail",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "eventPassword",
              "variableName": "eventPassword"
            },
            {
              "kind": "Variable",
              "name": "eventUser",
              "variableName": "eventUser"
            }
          ],
          "kind": "FragmentSpread",
          "name": "VideoPageAuthorizedData"
        }
      ],
      "type": "AuthorizedEvent",
      "abstractKey": null
    }
  ],
  "type": "Event",
  "abstractKey": "__isEvent"
};
})();

(node as any).hash = "957b1b0d7093044469a66301709e3e25";

export default node;
